Attributes of the position profile.
